import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
	isRouterAlive: true,
	activeIndex: '0',
	subActive: 'index',
	menuList: [],	
	user:{},    //用户信息
}

const mutations = {

}

const actions = {

}

export default new Vuex.Store({
	state,
	actions,
	mutations,
})



// WEBPACK FOOTER //
// ./src/store/index.js